import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success(t("auth.register_success"));
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("auth.register_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="register-page" className="min-h-screen flex items-center justify-center p-6 pt-32">
      <form onSubmit={submit} className="w-full max-w-md">
        <Link to="/" className="overline text-accent">{t("auth.back_to_site")}</Link>
        <h1 className="font-serif text-4xl mt-6">{t("auth.register_title")}</h1>
        <p className="text-muted-foreground mt-2">{t("auth.register_sub")}</p>

        <div className="mt-8 space-y-4">
          <div>
            <Label htmlFor="rname">{t("auth.full_name")}</Label>
            <Input data-testid="register-name" id="rname" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="remail">{t("auth.email")}</Label>
            <Input data-testid="register-email" id="remail" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="rphone">{t("auth.phone")}</Label>
            <Input id="rphone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="rpw">{t("auth.password")}</Label>
            <Input data-testid="register-password" id="rpw" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2" />
          </div>
          <button
            data-testid="register-submit"
            disabled={loading}
            className="btn-shimmer w-full py-3.5 rounded-full bg-foreground text-background hover:bg-accent transition-colors disabled:opacity-50 text-sm tracking-wide"
          >
            {loading ? t("auth.loading") : t("auth.submit_register")}
          </button>
        </div>

        <p className="mt-6 text-sm text-center text-muted-foreground">
          {t("auth.already")} <Link to="/login" className="text-accent hover:underline">{t("auth.login_link")}</Link>
        </p>
      </form>
    </main>
  );
};

export default RegisterPage;
